export default __webpack_public_path__ + "static/media/exhaustFan.9a1542c3.jpg";